2
import Vue from 'vue'
import * as THREE from "three";

import TWEEN from "@tweenjs/tween.js";

import {
    GUI
} from "three/examples/jsm/libs/dat.gui.module.js";

import Earth from "./Earth.js";
import Background from "./Background/";
// import UI from "./UI.js";
import {
    locations
} from "@/store/index.js";

const API = {
    // color: 0xffffff,
    mousemove: {
        tween: null
    },
    animated: false,
    gamma: 4.,
    exposure: 1,
    intensity: 40,
    material: {
        roughness: 1.0,
        metalness: 1.0
    },
    particles: {
        alpha: 0
    },
    // light: {
    //   position: new THREE.Vector3(0, 3.33, 2.128)
    // },
    camera: {
        position: new THREE.Vector3(0, 0, 0)
    },

    scalar: 2.5
    // intensity: 15
};
const SIMPLE_TEMP = true;
const offset = new THREE.Vector3();
const origin = new THREE.Vector3();
const panSpeed = 6.0

// var q = new THREE.Quaternion();
var cameraRotation = new THREE.Vector3();

var cameraV = new THREE.Vector3(0, 0, 0)
var panOffset = new THREE.Vector3(0, 0, 0)

let INTERSECTED = null;
var vertex = new THREE.Vector3();
var panStart = new THREE.Vector2();
var panEnd = new THREE.Vector2();
var panDelta = new THREE.Vector2();

export default class Scene {
    constructor({
        $el
    }) {
        this.tick = false;
        this.paning = false;

        this.sizes = {
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            }
        };
        this.mouse = new THREE.Vector2();
        this.INTERSECTED = null;

        this.scene = new THREE.Scene();

        // if(SIMPLE_TEMP) {
        this.camera = new THREE.PerspectiveCamera(
            50.0,
            this.sizes.viewport.width / this.sizes.viewport.height,
            0.1,
            10.0
        );

        this.wagon = new THREE.Object3D();
        this.wagon.add(this.camera);
        // this.camera.position.copy(API.camera.position)
        this.camera.translateZ(API.scalar);
        this.scene.add(this.wagon);
        // this.camera.useQuaternion = true
        // this.simpleMove = new SimpleMove(this.wagon)
        // this.scene.add(this.camera)
        // this.controls = new OrbitControls(this.camera)
        // this.controls.enableZoom = false;

        var canvas = $el;
        this.raycaster = new THREE.Raycaster();
        this.raycaster.params.Points.threshold = 0.01;
        this.renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            alpha: false,
            stencil: false,
            depth: true,
            powerPreference: "high-performance",
            // powerPreference: "low-battery",
            antialias: false
        });
        this.renderer.gammaFactor = API.gamma;
        this.renderer.gammaOutput = true;
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

        // var geometry = new THREE.SphereGeometry( 5, 32, 32 );
        // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.BackSide} );
        // var sphere = new THREE.Mesh( geometry, material );
        // this.scene.add( sphere );
        this.background = new Background({
            scene: this.scene
        });

        this.handleResize();
        this.x = this.handleResize.bind(this);
        window.addEventListener("resize", this.x, {
            passive: true
        });
        this.bindedHandleActive = this.handleActive.bind(this);
        this.bindedHandleUnactive = this.handleUnactive.bind(this);
        this.bindedHandlePan = this.handlePan.bind(this);
        this.bindedBasicPan = this.basicPan.bind(this);

        if (!Vue.mobile) {
            document.addEventListener(Vue.mobile ? "touchstart" : "click", e => this.handleClick(e), false);
            window.addEventListener(Vue.prototype.interaction.pan, this.bindedBasicPan, window.captureEvent);
        }

        this.loadAsset();
    }
    bindPaning($el) {
        if (!Vue.mobile) {
            $el.addEventListener(Vue.prototype.interaction.panStart, this.bindedHandleActive, false);
        }
    }
    unbindPaning($el) {
        $el.removeEventListener(Vue.prototype.interaction.pan, this.bindedHandlePan);
        document.body.removeEventListener(Vue.prototype.interaction.panStart, this.bindedHandleActive);
        document.body.removeEventListener(Vue.prototype.interaction.panEnd, this.bindedHandleUnactive);
        document.body.removeEventListener(Vue.prototype.interaction.unactive, this.bindedHandleUnactive);
    }
    loadAsset() {
        var manager = new THREE.LoadingManager(() => {
            this.loaded();
            // this.earth.mesh.rotation.y = -1.682
        });
        const {
            scene
        } = this;
        this.earth = new Earth({
            manager,
            scene
        });
    }
    loaded() {
        // this.setControls();
        this.animate();
    }
    setControls() {
        this.gui = new GUI();
        this.gui.add(API, "exposure", .1, 2.5, 0.001).onChange(value => {
            this.renderer.toneMappingExposure = value;
        });
    }
    handleActive(e) {
        if (!Vue.mobile) {
            const {
                clientX: x,
                clientY: y
            } = e.touches && e.touches[0] ? e.touches[0] : e
            this.mouse.x = (Math.round(x) / this.sizes.viewport.width) * 2 - 1;
            this.mouse.y = -(Math.round(y) / this.sizes.viewport.height) * 2 + 1;
            panStart.set(x, y)
            this.paning = true
            document.body.addEventListener(Vue.prototype.interaction.pan, this.bindedHandlePan, window.captureEvent);
            document.body.addEventListener(Vue.prototype.interaction.panEnd, this.bindedHandleUnactive, window.captureEvent);
            document.body.addEventListener(Vue.prototype.interaction.unactive, this.bindedHandleUnactive, window.captureEvent);
        }
    }
    handleUnactive(e) {
        this.paning = false
        document.body.removeEventListener(Vue.prototype.interaction.pan, this.bindedHandlePan);
        document.body.removeEventListener(Vue.prototype.interaction.panEnd, this.bindedHandleUnactive);
        document.body.removeEventListener(Vue.prototype.interaction.unactive, this.bindedHandleUnactive);
    }
    basicPan(e) {
        const {
            clientX: x,
            clientY: y
        } = e.touches && e.touches[0] ? e.touches[0] : e
        this.mouse.x = (Math.round(x) / this.sizes.viewport.width) * 2 - 1;
        this.mouse.y = -(Math.round(y) / this.sizes.viewport.height) * 2 + 1;
    }
    handlePan(e) {
        const {
            clientX: x,
            clientY: y
        } = e.touches && e.touches[0] ? e.touches[0] : e;

        if (this.paning) {
            var position = this.camera.position;
            offset.copy(position).sub(origin);
            var targetDistance = offset.length();
            targetDistance *= Math.tan((this.camera.fov / 2) * Math.PI / 180.0);

            panEnd.set(x, y)
            panDelta.subVectors(panEnd, panStart);

            panStart.copy(panEnd);
            const distanceX = panSpeed * panDelta.x * targetDistance / this.sizes.viewport.width
            const distanceY = panSpeed * panDelta.y * targetDistance / this.sizes.viewport.height
            //
            cameraV.setFromMatrixColumn(this.camera.matrix, 0)
            cameraV.multiplyScalar(-distanceX)
            panOffset.add(cameraV)
            cameraV.setFromMatrixColumn(this.camera.matrix, 1)
            cameraV.multiplyScalar(distanceY)
            panOffset.add(cameraV)
            this.camera.position.add(panOffset).normalize().multiplyScalar(API.scalar)
            this.camera.lookAt(origin)

            panOffset.set(0, 0, 0);
        }
    }
    animate() {
        this.frameId = requestAnimationFrame(() => this.animate());
        this.render();
    }
    render() {
        this.background.mesh.material.uniforms.offset.value = this.camera.position.y;
        // this.camera.updateMatrixWorld();
        this.raycaster.setFromCamera(this.mouse, this.camera);
        if (this.earth && this.earth.countries) {
            let attributes = this.earth.countries.geometry.attributes;
            var intersects = this.raycaster.intersectObject(this.earth.countries);
            if (intersects.length > 0 && intersects[0].distance < API.scalar) {
                document.body.classList.add("pointed");
                const idx = intersects[0].index;
                if (idx !== locations.idx) {
                    locations.idx = idx;
                }
                INTERSECTED = vertex.fromBufferAttribute(attributes.position, idx);
                let screenPos = this.getScreenXY(INTERSECTED.clone());
                screenPos.x = Math.round(screenPos.x * this.sizes.viewport.width * 0.5);
                screenPos.y = Math.round(
                    screenPos.y * this.sizes.viewport.height * 0.5
                );
                locations.helper = screenPos;
            } else {
                if (locations.idx !== -1) {
                    locations.idx = -1;
                }
                document.body.classList.remove("pointed");
            }
            const lerp = (3.0 - API.scalar) * 2.0
            this.earth.mesh.material.uniforms.gamma.value = (5.215 - 2.2) * lerp + 2.2
            this.earth.mesh.material.uniforms.vAlpha.value = (.725 - 1.0) * lerp + 1.0
            this.background.mesh.material.uniforms.gamma.value = (1.125 - 1.0) * lerp + 1.0
            TWEEN.update();
        }

        this.renderer.render(this.scene, this.camera);
    }
    selectedPointsAttributes(idx) {
        let attributes = this.earth.countries.geometry.attributes;
        const point = vertex.fromBufferAttribute(attributes.position, idx);
        let screenPos = this.getScreenXY(point.clone());
        screenPos.x = Math.round(screenPos.x * this.sizes.viewport.width * 0.5);
        screenPos.y = Math.round(screenPos.y * this.sizes.viewport.height * 0.5);
        return screenPos;
    }
    getScreenXY(position) {
        var vector = position.clone();
        this.camera.updateProjectionMatrix();
        vector.project(this.camera);
        return vector;
    }
    setState(idx) {
        if (!this.earth.countries) {
            return
        }
        const newPosition = [
            new THREE.Vector3(0, -1.125, 0),
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(0, 1.125, 0)
        ][idx];
        const uAlpha = [0, 1, 0][idx];
        const newScalar = [2.5, 3, 2.5][idx];
        let camPos = this.camera.position.clone();
        new TWEEN.Tween(API)
            .to({
                scalar: newScalar
            }, 1200)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(() => {
                this.camera.position.copy(
                    camPos.normalize().multiplyScalar(API.scalar)
                );
            })
            .start();
        new TWEEN.Tween(API.particles)
            .to({
                alpha: uAlpha
            }, 1200)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(() => {
                this.earth.countries.material.uniforms.uAlpha.value =
                    API.particles.alpha;
            })
            .start();

        let wagPos = this.earth.vessel.position.clone();
        let newPos = newPosition.clone();
        new TWEEN.Tween(wagPos)
            .to(newPos, 1200)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(() => {
                this.earth.vessel.position.copy(wagPos);
            })
            .start();

        this.moveCamera(-1, 1200);
    }
    moveCamera(idx = -1, timing = false) {
        if (idx > -1) {
            var geometry = this.earth.countries.geometry;
            var attributes = geometry.attributes;
            cameraRotation.fromBufferAttribute(attributes.position, idx);
            var position = cameraRotation.clone().normalize();
        } else {
            position = new THREE.Vector3(0, 0, 1);
        }

        let camPos = this.camera.position.clone().normalize();

        var d = position.distanceTo(camPos);

        new TWEEN.Tween(camPos)
            .to(position, timing || Math.max(d * 1200, 250))
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(() => {
                this.camera.position.copy(
                    camPos.normalize().multiplyScalar(API.scalar)
                );
                this.camera.lookAt(this.wagon.position);
            })
            .start();
    }
    selectIndex(idx) {
        if (idx !== -1) {
            this.moveCamera(idx);
            let attributes = this.earth.countries.geometry.attributes;
            attributes.visibility.array[locations.selectedIdx] = 1.0;
            locations.selectedIdx = idx;
            attributes.visibility.array[locations.selectedIdx] = 0.0;
            attributes.visibility.needsUpdate = true;
        }
    }
    handleClick() {
        if (locations.idx !== null && locations.idx !== -1) {
            locations.currentCountry = locations.data[locations.idx].id;
            this.selectIndex(locations.idx);
        }
    }
    handleResize() {
        this.sizes.viewport.width = window.innerWidth;
        this.sizes.viewport.height = window.innerHeight;
        this.sizes.viewport.width = window.innerWidth;
        this.sizes.viewport.height = window.innerHeight;
        this.camera.aspect = this.sizes.viewport.width / this.sizes.viewport.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(
            this.sizes.viewport.width,
            this.sizes.viewport.height
        );
        this.render();
    }
    destroy() {
        // this.time.off("tick");
        cancelAnimationFrame(this.frameId);
        window.removeEventListener("resize", this.x);
        if (!SIMPLE_TEMP) {
            document.removeEventListener("mousemove", this.y);
        }
        this.renderer.dispose();
        // this.freeCamera.dispose();

        if (!SIMPLE_TEMP) {
            this.controles.dispose();
        }
        this.earth.dispose();
        // TWEEN.removeAll();

        if (!SIMPLE_TEMP) {
            if (this.gui) this.gui.destroy();
        }
    }
}